<template>
    <div class="container contactus-container">
        <div class="contactus-title">{{ $t('contact0') }}</div>

        <div class="contact-left">
            <div class="contact-left-title">Vindome EOOD</div>
            <div class="contact-left-subtitle">9 Simeonovsko shose Blvd</div>
            <div class="contact-left-subtitle">entr. E, fl. 7, apt. 115</div>
            <div class="contact-left-subtitle">1700, Sofia</div>
            <div class="contact-left-subtitle">Bulgaria</div>
            <a class="contact-left-subtitle" href="tel:+33645451650">+33 6 45 45 16 50</a>
            <a class="contact-left-subtitle" href="mailto:info@vindome.net">info@vindome.net</a>
        </div>
        <div class="contact-right">
            <div class="contact-wrapper" v-if="!successMessage">
                <v-flex>
                    <span class="login-label">{{ $t('contact1') }}</span>
                    <v-text-field
                        v-model="loginName"
                        class="email-input"
                        :rules="[rules.required]"
                    ></v-text-field>
                </v-flex>

                <v-flex>
                    <span class="login-label">{{ $t('contact2') }}</span>
                    <v-text-field
                        v-model="loginEmail"
                        class="email-input"
                        :rules="[rules.required, rules.emailValid]"
                    ></v-text-field>
                </v-flex>

                <v-flex>
                    <span class="login-label">{{ $t('contact3') }}</span>
                    <v-textarea
                        class="contact-textarea"
                        :rules="[rules.required]"
                        v-model="notes"
                        rows="3"
                    ></v-textarea>
                </v-flex>
                <div v-if="showError" class="contact-error">Please fill all fields</div>
                <v-btn class="submit-btn" text v-on:click="sendContact">{{ $t('contact4') }}</v-btn>
            </div>
            <div class="contact-wrapper success-wrapper" v-else>
                <div class="success-title">{{ $t('contact5') }}</div>
                <div class="success-info">{{ $t('contact6') }}</div>
                <v-btn class="done-btn" text v-on:click="resetForm">{{ $t('contact7') }}</v-btn>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "Contact",
        head: {
            title: 'Contact us | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'page-contact trading-desk'
            }
        },
        data() {
            return {
                loginName: '',
                loginEmail: '',
                notes: '',
                reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
                rules: {
                    required: value => !!value || 'Required.',
                    min: value => value.length >= 8 || 'Min 8 characters',
                    emailValid: value => this.reg.test(value) || 'Invalid email'

                },
                successMessage: false,
                showError: false
            }
        },
        methods: {
            async sendContact() {
                if (this.loginName === '' || this.loginEmail === '' || this.notes === '') {
                    this.showError = true;
                    return
                }

                let contactCtrl = this;
                let options = {
                    method: 'POST',
                    url: 'https://forms.raketa.cloud/submit/XXj4SzpmtB',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json;charset=UTF-8'
                    },
                    data: {
                        data: {
                            name: this.loginName,
                            email: this.loginEmail,
                            message: this.notes
                        }
                    }
                };
                let response = await axios(options);
                let responseOK = response && response.status === 200 && response.statusText === 'OK';
                if (responseOK) {
                    contactCtrl.successMessage = true
                }
            },
            resetForm() {
                this.loginName = '';
                this.loginEmail = '';
                this.notes = '';
                this.successMessage = false
            }
        }
    }
</script>

<style scoped>
    .contact-error {
        color: red;
    }

    .contactus-container {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        background: #ffffff;
        max-width: 982px;
        padding: 127px 0 0 0;
    }

    .contactus-title {
        text-align: center;
        color: #303030;
        font-size: 49px;
        line-height: 49px;
        font-weight: 400;
        margin-bottom: 47px;
    }

    .contact-left, .contact-right {
        display: inline-block;
        width: calc((100% - 38px) / 2);
        vertical-align: top;
    }

    .contact-left {
        margin-right: 32px;
        border: 1px solid #CCCCCC;
        box-sizing: border-box;
        border-radius: 4px;
        padding: 53px 32px;
    }

    .contact-left-title {
        font-style: normal;
        font-weight: 600;
        font-size: 19px;
        line-height: 120%;
        margin-bottom: 16px;
    }

    .contact-left-subtitle {
        font-size: 16px;
        font-weight: 300;
        color: #303030;
        display: block;
        margin-top: 8px;
        text-decoration: none;
    }

    .contact-wrapper {
        background: #F6F6F6;
        border-radius: 8px;
        padding: 27px 56px 32px 32px;
        margin-bottom: 54px;
    }

    .submit-btn {
        margin-top: 15px;
        background: #E1C376 !important;
        color: #FFF !important;
        width: 200px;
        height: 40px !important;
        font-size: 18px;
        border-radius: 5px;
        text-transform: none;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        letter-spacing: 0;
        font-weight: lighter;
        box-shadow: none;
        margin-left: 0;
        margin-right: 0;
    }

    .success-wrapper {
        text-align: center;
        background: url('../assets/success.png') no-repeat center 80px;
        border: 1px solid #ccc;
        padding: 200px 32px 50px;
    }

    .success-title {
        color: #024E7B;
        font-weight: bold;
        font-size: 22px;
        margin-top: 50px;
    }

    .success-info {
        color: #303030;
    }

    .done-btn {
        background: #E1C376 !important;
        color: #FFF !important;
        margin-top: 50px;
        width: 200px;
        height: 40px !important;
        font-size: 18px;
        border-radius: 5px;
        text-transform: none;
    }

    .login-label {
        position: absolute;
        font-size: var(--fs-base);
        color: #303030;
        font-weight: 300;
    }

    @media (max-width: 767px) {
        .contactus-title {
            font-size: 30px;
            line-height: 33px;
            margin-bottom: 27px;
        }

        .contact-left,
        .contact-right {
            width: 100%;
            margin-right: 0;
        }

        .contact-left {
            margin-bottom: 32px;
        }

        .contactus-container {
            padding: 100px 15px 0;
        }
    }
</style>
<style>
    .page-contact .theme--light.v-application {
        background: #ffffff;
    }

    .page-contact .flex {
        margin-top: 20px;
        text-align: left;
    }

    .page-contact textarea {
        background: #ffffff;
        margin-top: 20px;
    }

    .page-contact .v-input input {
        height: 40px;
        max-height: unset;
        margin-top: 20px;
        padding-left: 15px;
    }

    .page-contact.v-text-field .v-input__append-inner {
        margin-top: 20px;
        background: #fff;
        height: 40px;
    }

    .page-contact .v-text-field .v-input__append-inner .v-input__icon {
        margin-top: 12px;
    }

    .page-contact .v-text-field .v-input__append-inner .primary--text {
        color: #000 !important;
        caret-color: #000 !important;
    }

    .page-contact .theme--light.v-input:not(.v-input--is-disabled) input {
        border: 0;
    }

    .page-contact .theme--light.v-text-field:not(.v-input--has-state) > .v-input__control > .v-input__slot:hover:before {
        border-color: var(--brand);
    }

    .page-contact .theme--light.v-text-field > .v-input__control > .v-input__slot:after {
        border-color: rgba(0, 0, 0, .87);
        border-width: 1px;
    }

    .page-contact.theme--light.v-text-field.error--text > .v-input__control > .v-input__slot:after {
        border-color: #ff5252;
    }
</style>
